import React from 'react';
import PropTypes from 'prop-types';
import {employeesTest} from "../../../../helpers/employees-test";
import Employee from "../../Templates/Employee";
import TableOptionsButton from "../../TableOptionsButton";
import TableRow from "../../../Wrappers/TableRow";

const InabilityNoveltyRow = props => {
  const { data } = props
  return (
    <TableRow>
      <p className="s-mb-0">{data.id}</p>
      <p className="s-mb-0">{data.type}</p>
      <Employee employee={employeesTest[0]} />
      <p className="s-mb-0">{data.start}</p>
      <p className="s-mb-0 s-color-red">{data.end}</p>
      <p className="s-mb-0">{data.extension}</p>
      <TableOptionsButton
        deleteFunction={() => {}}
        editFunction={() => {}}
      />
    </TableRow>
  );
};

InabilityNoveltyRow.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    extension: PropTypes.string.isRequired,
  }).isRequired,
};

InabilityNoveltyRow.defaultProps = {
  data: {
    end: '-- / -- / --',
  },
}

export default InabilityNoveltyRow;
